import React from 'react';

export const NotifyContainer = () => {
    return <div id="notify-parent" />;
};
